import { QueryKey } from '@tanstack/react-query'

export const QueryKeys = {
  NEWS: ['news'] as const,
  NEWS_FEED: 'feed',
  NEWS_POST: 'post',
  NEWS_COMMENTS: 'comments',
  ACTIVE_MEMBERS: ['users', 'active'] as QueryKey,
  ALL_MEMBERS: ['users', 'all'] as QueryKey,
  NEWSLETTERS: ['newsletters'] as QueryKey,
  INVITATIONS: ['invitations'] as QueryKey,
  ADMIN_INVITATIONS: ['invitations', 'admin'] as QueryKey,
  NEWSLETTER_RECIPIENT_COUNT: ['newsletter', 'recipientCount'] as QueryKey,
} as const
